import { forwardRef } from "react";
import type { FlatList } from "react-native";

/* -----------------UI--------------- */
/* -----------------Types--------------- */
import type { SessionItem } from "@memorang/types/src/session/new-session";

import Box from "@memorang/ui/src/components/Box";
/* -----------------Child components--------------- */
import SessionListDesktop from "./SessionListDesktop";

interface Props {
	items: SessionItem[];
	toggleShowReadMore: () => void;
}

const SessionList = forwardRef<FlatList, Props>(
	({ items, toggleShowReadMore }) => {
		return (
			<Box gap={16} flexGrow={1} alignItems="center" height="100%">
				<SessionListDesktop
					items={items}
					toggleShowReadMore={toggleShowReadMore}
				/>
			</Box>
		);
	},
);
export default SessionList;
